const iconMixin = (fontSize) => {
  return `
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: ${fontSize};
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;
    vertical-align: middle;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'liga';
    position: relative;
  `;
};

export default iconMixin;
